module.exports = __webpack_public_path__ + "img/20210726_091709.1a98c773.jpg";